export enum PartnerEndpoint {
  Base = '/partners',
  Approve = '/approve',
  Carriers = '/carriers',
  Search = '/search',
  Exports = '/exports',
  Extended = '/extended',
  ShortNames = '/short-names',
}
